<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { setImgDomain } from '@/assets/api/token.js';
import { getDicts } from '@/assets/api';

export default {
  mounted() {
    const navigationType = performance.getEntriesByType('navigation')[0].type;
    if (navigationType === 'reload') {
      console.log('这是刷新操作！');
      this.handleRefresh();
    }
  },
  methods: {
    getUrlDomain() {
      getDicts('img_domain').then((res) => {
        if (res.code == 200) {
          setImgDomain(res.data[0].dictValue);
        }
      });
    },
    handleRefresh() {
      this.getUrlDomain();
      this.$store.dispatch('getSite');
    }, //获取站点和导航}
  },
};
</script>

<style>
/* 设置默认字体，确保rem适配 */
page {
  font-family: SourceHanSansCN-Normal;
  font-size: 16px;
}
#app {
  font-family: SourceHanSansCN-Normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #424451;
  overflow-x: hidden;
}
/* 全局样式 */
:root {
  --primary-color: #3498db;
  --secondary-color: #2980b9;
  --text-color: #333;
  --light-text: #777;
  --bg-color: #f9f9f9;
  --max-width: 1505px;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: SourceHanSansCN-Normal;
  line-height: 1.6;
  color: var(--text-color);
  background-color: var(--bg-color);
  font-size: 16px;
}

@media (max-width: 1200px) {
  html {
    font-size: 15px;
  }
}

@media (max-width: 992px) {
  html {
    font-size: 14px;
  }
}

@media (max-width: 768px) {
  html {
    font-size: 13px;
  }
}

@media (max-width: 576px) {
  html {
    font-size: 12px;
  }
}

h1 {
  font-size: clamp(1.8rem, 5vw, 2.5rem);
  margin-bottom: 1rem;
}

h2 {
  font-size: clamp(1.5rem, 4vw, 2rem);
  margin-bottom: 0.8rem;
}

p {
  font-size: clamp(1rem, 2.5vw, 1.1rem);
  /* margin-bottom: 1rem; */
}

/* 容器布局 */
.container {
  width: 100%;
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 0 1rem;
}

/* 按钮样式 */
.btn {
  display: inline-block;
  padding: 0.8rem 1.5rem;
  background-color: white;
  color: var(--primary-color);
  border-radius: 4px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s;
  border: none;
  cursor: pointer;
}

.btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.btn-primary {
  background-color: var(--primary-color);
  color: white;
}

.btn-primary:hover {
  background-color: var(--secondary-color);
}

.section-title {
  text-align: center;
  margin-bottom: 3rem;
}
</style>
<style lang="scss" scoped>
@import '@/assets/styles/vhtml.scss';
</style>
